import React from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { useFormikContext, FieldArray } from "formik";
import { fieldConfig } from "../config/fieldConfig";

const ItinerarySection = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="h6" gutterBottom>
        Itinerary
      </Typography>

      <Typography variant="body2" color="textSecondary" gutterBottom>
        Please provide the details of your tour itinerary below. This section
        allows you to outline each day of your tour, including locations,
        activities, and times.
      </Typography>

      <FieldArray name="itinerary">
        {({ push, remove }) => (
          <>
            {values.itinerary.map((item, index) => (
              <Box
                key={index}
                p={2}
                border={1}
                borderColor="grey.300"
                borderRadius={2}
                display="flex"
                flexDirection="column"
                gap={2}
              >
                {Object.entries(fieldConfig.itinerary).map(
                  ([field, config]) => (
                    <TextField
                      key={field}
                      fullWidth
                      label={config.label}
                      placeholder={config.placeholder}
                      name={`itinerary[${index}].${field}`}
                      value={values.itinerary[index][field]}
                      onChange={handleChange}
                      helperText={config.helperText}
                    />
                  )
                )}
                <Box>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => remove(index)}
                    aria-label={`Remove itinerary day ${index + 1}`}
                  >
                    Remove Day
                  </Button>
                </Box>
              </Box>
            ))}
            <Button
              variant="outlined"
              color="primary"
              onClick={() =>
                push({
                  day: "",
                  title: "",
                  description: "",
                  location: "",
                  startTime: "",
                  endTime: "",
                })
              }
              sx={{ mt: 2 }}
            >
              Add Day
            </Button>
          </>
        )}
      </FieldArray>
    </Box>
  );
};

export default ItinerarySection;
